import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchAllTemplates,
  fetchAssignedData,
  fetchshuffleData,
  fetchfollowupshuffleData,
  fetchInstantlyCampaign,
  createInstantlyCampaignApi,
  sendBulkEmailsStartApi,
  fetchInstantlyAccessId,
} from "./compaignsApi";
import {
  getTemplatesFailure,
  getTemplatesStart,
  getTemplatesSuccess,
  getAssignDataStart,
  getAssignDataSuccess,
  getAssignDataFailure,
  getFollowAssignDataStart,
  getFollowAssignDataSuccess,
  getFollowAssignDataFailure,
  saveShuffleStart,
  saveShuffleSuccess,
  saveShuffleFailure,
  getInstantlyCampaign,
  successInstantlyCampaign,
  createInstantlyCampaign,
  successCreateInstantlyCampaign,
  sendBulkEmailsStart,
  successSendBulkEmailsStart,
  failureSendBulkEmailsStart,
  getInstantlyAccessId,
  successGetInstantlyAccessId,
} from "./compaignsSlice";
import { showToast } from "../../../components";

function* fetchTemplatesSaga(action) {
  try {
    const response = yield call(fetchAllTemplates, action.payload);
    yield put(
      getTemplatesSuccess({
        data: response.data || [],
      })
    );
  } catch (error) {
    yield put(
      getTemplatesFailure(error.message || "Failed to fetch templates")
    );
  }
}
function* fetchAssignDataWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload;
    const response = yield call(fetchAssignedData, params);
    const assignData = response?.data?.data || [];
    yield put(
      getAssignDataSuccess({
        data: assignData,
        total: response?.data?.total || assignData.length || 0,
      })
    );

    // Optional: callback
    if (onSuccess) onSuccess(assignData);

    // Optional: success toast
    // showToast("Assigned data fetched successfully", "success", 2000);
  } catch (error) {
    yield put(getAssignDataFailure(error.message));
    showToast(error.message || "Failed to fetch assigned data", "error", 2000);
  }
}
function* fetchFollowAssignDataWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload;
    const response = yield call(fetchAssignedData, params);
    const followData = response?.data?.data || [];

    yield put(
      getFollowAssignDataSuccess({
        data: followData,
      })
    );

    if (onSuccess) onSuccess(followData);
  } catch (error) {
    yield put(getAssignDataFailure(error.message));
  }
}
function* saveShuffleWorker(action) {
  try {
    const { onSuccess, payload } = action.payload;

    const response = yield call(fetchshuffleData, { payload });

    if(response?.data) {
      showToast("Shuffle saved successfully!", "success", 2000);
    } else {
      showToast("Failed to save!", "error", 2000);
    }

    const shuffleData = response?.data?.data || {};

    yield put(saveShuffleSuccess({ data: shuffleData }));

    if (onSuccess) onSuccess(shuffleData);

    // showToast("Shuffle saved successfully!", "success", 2000);
  } catch (error) {
    yield put(saveShuffleFailure(error.message));
    showToast(error.message || "Failed to save shuffle", "error", 2000);
  }
}

function* fetchFollowUpShuffleWorker(action) {
  try {
    const params = action.payload; // { coll, lim, pg, ref, extret }
    const response = yield call(fetchfollowupshuffleData, params);
    const shuffleData = response?.data?.data || [];

    yield put(getFollowAssignDataSuccess({ data: shuffleData }));
  } catch (error) {
    yield put(getAssignDataFailure(error.message));
    showToast(error.message || "Failed to fetch shuffle data", "error", 2000);
  }
}
function* getInstantlyCampaignSaga(action) {
  const { payload, onSuccess } = action.payload;
  try {
    const response = yield call(fetchInstantlyCampaign, payload);
    if (response?.success) {
      yield put(
        successInstantlyCampaign({
          data: response?.data?.data?.mergedData,
          nextpage: response?.data?.data?.nextPage,
        })
      );
      if (onSuccess) {
        onSuccess({
          items: response?.data?.data?.mergedData,
          nextpage: response?.data?.data?.nextPage,
        });
      }else{
        onSuccess({

        })
      }
    } else {
      yield put(successInstantlyCampaign({ data: [], nextpage: null }));
    }
  } catch (error) {
    onSuccess({

        })
    yield put(successInstantlyCampaign({ data: [], nextpage: null }));
  }
}
function* createInstantlyCampaignSaga(action) {
  const { payload, onSuccess, accessId } = action.payload;
  try {
    const response = yield call(createInstantlyCampaignApi, {
      accessId,
      payload,
    });

    if (response?.success) {
      onSuccess(true, response);
    } else {
      onSuccess(false, response);
    }
  } catch (error) {
    onSuccess(false, null);
  }
}

function* sendBulkEmailsStartSaga(action) {
  try {
    const { payload, onSuccess } = action.payload;
    const response = yield call(sendBulkEmailsStartApi,{ payload });
    if (response?.success) {
      if (onSuccess) {
        onSuccess();
      }
      yield put(successSendBulkEmailsStart({}));
    } else {
      yield put(successSendBulkEmailsStart({}));
    }
  } catch (error) {
    yield put(failureSendBulkEmailsStart(error));
  }
}
function* getInstantlyAccessIdSaga(action){
//  const { payload, onSuccess, accessId } = action.payload;
  try {
 const response = yield call(fetchInstantlyAccessId,action.payload);
    if (response?.success) {
      // onSuccess(response);
      const accessId= response?.data?.data?.uiid
      if(accessId){
        yield put(successGetInstantlyAccessId(accessId))
      }
    }
  }catch (error) {
    //  yield put (successCreateInstantlyCampaign({}))
  }
}

export function* watchCompaigns() {
  yield takeLatest(getTemplatesStart.type, fetchTemplatesSaga);
  yield takeLatest(getAssignDataStart.type, fetchAssignDataWorker);
  // yield takeLatest(getFollowAssignDataStart.type, fetchFollowAssignDataWorker);
  yield takeLatest(getFollowAssignDataStart.type, fetchFollowUpShuffleWorker);
  yield takeLatest(saveShuffleStart.type, saveShuffleWorker);
  yield takeLatest(getInstantlyCampaign.type, getInstantlyCampaignSaga);
  yield takeLatest(createInstantlyCampaign.type, createInstantlyCampaignSaga);
  yield takeLatest(sendBulkEmailsStart.type, sendBulkEmailsStartSaga);
  yield takeLatest(getInstantlyAccessId.type,getInstantlyAccessIdSaga)
}
